// extracted by mini-css-extract-plugin
export default {"customRow":"BankStatementTable_customRow__yejk8","customThumbTable":"BankStatementTable_customThumbTable__1U-A9"};